import translate from "@bimproject/t9n";
import { useMemo } from "react";
import styled from "styled-components";


import { useDialog } from "~/src/modules/ui-kit";

import { Finder2, useFinder } from "../../../modules/finder";
import { useParameter, useParameters } from "../../../modules/shared-entities";
import * as UI from "../../../modules/ui-kit";



const Piv = styled.div<{ $deprecated?: boolean }>`
    color: ${ (props) => props.$deprecated ? "#0004" : "#000" };
`;

export default styled(UI.ListInput).attrs(
    {
        Add: ParameterAdder,
        Input: Parameter,
        label: "parameter",
    }
)`
    ol {
        grid-template-columns: 1fr min-content min-content min-content !important;
    }
`;

function ParameterAdder(props) {
    const { label, onAdd } = props;

    const [Dialog, open] = useDialog();

    return (
        <>
            <UI.Button onClick={ open }>Add { label }</UI.Button>
            <StyledDialog as={ Dialog }>
                <Finder2>
                    <ParameterFinderPlugin
                        Component={
                            (p) => <Piv {...p}>{ p.name } [{ p.dataType }]</Piv>
                        }
                        onSelect={ (x) => onAdd(x.id) }
                    />
                </Finder2>
            </StyledDialog>
        </>
    );
}

const StyledDialog = styled.dialog`
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 32px;
    height: calc(100vh - 2 * 128px);
    left: 192px;
    max-width: calc((100% - 192px - 128px) / 2);
    overflow: hidden;
    padding: 0;
    position: fixed;
    top: 128px;

    &::backdrop {
        background: #0007;
    }

    & > div {
        overflow: auto;
    }

    body:has(&[open]) {
        overflow: hidden;
    }
`;

const Span = styled.span`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

function Parameter(props) {
    const { all, i, onMove, value } = props;

    const parameterQuery = useParameter(value);
    if (!parameterQuery.data) return undefined;

    return (
        <>
            <Span>{ translate(parameterQuery.data?.parameter?.name) } [{ parameterQuery.data?.parameter?.dataType }]</Span>
            { i !== 0 ? <UI.Button onClick={ () => onMove(-1) }>move up</UI.Button> : <span /> }
            { i !== all.length - 1 ? <UI.Button onClick={ () => onMove(1) }>move down</UI.Button> : <span /> }
        </>
    );
}

function ParameterFinderPlugin(props) {
    const { Component, onSelect } = props;

    const { token } = useFinder();

    const parameters = useParameters();
    const items = useMemo(
        () => {
            if (!parameters.data?.parameters) return undefined;
            return parameters.data.parameters.map(
                (p) => {
                    return {
                        id: p.id,
                        name: p.name[0].text,
                        dataType: p.dataType,
                        $deprecated: p.deprecated,
                    };
                }
            );
        },
        [parameters.data?.parameters],
    );

    if (!items) return undefined;

    return (
        <>
            {
                items.filter(
                    (item) => !item.selected
                ).filter(
                    (item) => item.name.toLowerCase().includes(token.toLowerCase()) || item.id === token
                ).sort(
                    (a, b) => a.name.localeCompare(b.name)
                ).map(
                    (item) => (
                        <li key={ item.id }>
                            <Component
                                { ...item }
                                onClick={ () => onSelect(item) }
                            />
                        </li>
                    )
                )
            }
        </>
    );
}
